module.exports = __webpack_public_path__ + "static/media/project21.779baa2d.jpg";